var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Matter',{attrs:{"hasFilterContact":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }